module.exports = __webpack_public_path__ + "media/images/themes/pink_softness/main_bg-d7988bccbca2bfbb21dfad62b99ce4cf.png";